import * as React from "react";
import { memo } from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 8, viewBox: "0 0 7 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.58527 3.56791L1.25194 0.456803C0.918607 0.262362 0.5 0.502797 0.5 0.888692V7.11092C0.5 7.49681 0.918607 7.73725 1.25194 7.5428L6.58527 4.43169C6.91602 4.23875 6.91602 3.76085 6.58527 3.56791Z", fill: "currentColor" }));
const Memo = memo(SvgPlay);
export default Memo;
